import util from '@/libs/util.js'

export default {
  namespaced: true,
  mutations: {
    /**
     * @description 显示版本信息
     * @param {Object} state state
     */
    versionShow () {
      util.log.capsule('RMT.WORK', `v${process.env.VUE_APP_VERSION}`)
      console.log('融媒体综合解决方案，欢迎联系我们：contact@rmt.work ~')
    }
  }
}
